import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'bor-search-home',
  standalone: false,
  templateUrl: './search-home.component.html',
  styleUrl: './search-home.component.scss',
})
export class SearchHomeComponent {

  searchTerm!: string;

  hasError = false;

  router = inject(Router);

  onSearch(){
    this.hasError = false;
    this.searchTerm = this.searchTerm?.trim() || '';

    if(this.searchTerm === ''){
      this.hasError = true;
      return;
    }

    this.router.navigateByUrl('/search/results?q=' + this.searchTerm);
  }
}
